
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"-223 25 512 512","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M244 101h-14.8v225c0 41.4-33.8 75-75.2 75H-7.4l-32 29.8H87.8l85.6 85.8c9.4 9.4 25.6 2.8 25.6-10.6v-75.2h45c24.8 0 45-20 45-44.8V146c0-24.8-20.2-45-45-45z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M154 41h-332c-24.8 0-45 20.2-45 45v240c0 24.8 20.2 45 45 45h45v75c0 13.4 16.2 20 25.6 10.6l81.2-81.2c2.8-2.8 6.6-4.4 10.6-4.4H154c24.8 0 45-20.2 45-45V86c0-24.8-20.2-45-45-45zM94.7 99.2V311h-230.1V82.2H94.8v17z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M-14.8 159.6v36.1l27.1-12.2v-57.4H-11v2.4c0 1.1-.7 2-2.4 3.6s-3.4 3.4-9.8 7.4c-4.4 2.7-18.6 9.2-18.6 9.2l9.3 20.1 17.7-9.2z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M-118.5 99.2V294H77.7V99.2h-196.2zm67.7 167.3h-20.8v-75.2h20.8v75.2zm-10.4-83.9c-7.5 0-13.5-6.1-13.5-13.5 0-7.5 6.1-13.5 13.5-13.5s13.5 6.1 13.5 13.5c.1 7.4-6 13.5-13.5 13.5zm38-43.2c6.5-3.9 8.1-5.7 9.8-7.4s2.4-2.5 2.4-3.6V126h23.3v57.4l-27.1 12.2v-36.1l-17.8 9.1-9.3-20.1c.1.1 14.3-6.4 18.7-9.1zM32 267.1h-68.1V245h21.3v-33.6l27.1-13.1V245H32v22.1z"}})])
          )
        }
      }
    